import { render, staticRenderFns } from "./AS_About.vue?vue&type=template&id=2562edd3&scoped=true&"
import script from "./AS_About.vue?vue&type=script&lang=js&"
export * from "./AS_About.vue?vue&type=script&lang=js&"
import style0 from "./AS_About.vue?vue&type=style&index=0&id=2562edd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2562edd3",
  null
  
)

export default component.exports